exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".root---3x-Xr{height:5rem;background-color:#add8e6;display:flex;justify-content:center;align-items:center;font-size:30px}.play---3AxsJ:before{content:\" \\25B6\"}.stop---3NTU7:before{content:\" \\25FE\"}", ""]);

// Exports
exports.locals = {
	"root": "root---3x-Xr",
	"play": "play---3AxsJ",
	"stop": "stop---3NTU7"
};